import {DashboardLayout} from "../../layout/dashboard.layout";
import {useTranslation} from "react-i18next";
import {DASHBOARD, SENDER_NAMES_CREATE} from "../../../routes/frontend.routes";
import {createColumnHelper} from "@tanstack/react-table";
import {IndeterminateCheckbox} from "../../../../app-common/components/input/checkbox.intermediate";
import React from "react";
import {TableComponent} from "../../../../app-common/components/table/table";
import {SENDER_NAME_BULK_DELETE, SENDER_NAME_LIST} from "../../../../api/routing/routes/backend.app";
import {Link} from "react-router-dom";
import moment from "moment";
import {SenderName} from "../../../../api/model/user";
import 'react-confirm-alert/src/react-confirm-alert.css';

export const SenderNames = () => {
  const {t} = useTranslation();
  const columnHelper = createColumnHelper<SenderName>();

  const columns = [
    columnHelper.accessor('uuid', {
      enableSorting: false,
      header: ({table}) => (
        <div className="px-1">
          <IndeterminateCheckbox
            {...{
              checked: table.getIsAllRowsSelected(),
              indeterminate: table.getIsSomeRowsSelected(),
              onChange: table.getToggleAllRowsSelectedHandler(),
            }}
          />
        </div>
      ),
      cell: ({row, cell}) => (
        <div className="px-1">
          <IndeterminateCheckbox
            {...{
              checked: row.getIsSelected(),
              indeterminate: row.getIsSomeSelected(),
              onChange: row.getToggleSelectedHandler(),
              value: cell.getValue()
            }}
          />
        </div>
      ),
    }),
    columnHelper.accessor('name', {
      header: () => t('Name'),
    }),
    columnHelper.accessor('isApproved', {
      header: () => t('Approved?'),
      cell: info => info.getValue() ? t('Yes') : t('No')
    }),
    columnHelper.accessor('isActive', {
      header: () => t('Active?'),
      cell: info => info.getValue() ? t('Yes') : t('No')
    }),
    columnHelper.accessor('updatedAt.datetime', {
      header: () => t('Updated at'),
      cell: info => moment(info.getValue()).format('lll')
    })
  ];

  return (
    <DashboardLayout
      title="Sender Names"
      breadCrumbs={[
        {title: t('Dashboard'), link: DASHBOARD},
        {title: t('Sender Names'), current: true}
      ]}
      buttons={[
        <Link to={SENDER_NAMES_CREATE} className="float-end btn btn-primary">{t('Create')}</Link>
      ]}
    >
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">
                {t('List')}
              </h5>
              <TableComponent columns={columns} url={SENDER_NAME_LIST} selectionButtons={[{
                title: <i className="bi bi-trash3"></i>,
                type: 'bulkDelete',
                className: 'btn btn-danger',
                url: SENDER_NAME_BULK_DELETE
              }]}/>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};
